/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StockInboundDetailResVo } from './StockInboundDetailResVo';
import {
    StockInboundDetailResVoFromJSON,
    StockInboundDetailResVoFromJSONTyped,
    StockInboundDetailResVoToJSON,
    StockInboundDetailResVoToJSONTyped,
} from './StockInboundDetailResVo';

/**
 * 
 * @export
 * @interface ResponseListStockInboundDetailResVo
 */
export interface ResponseListStockInboundDetailResVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListStockInboundDetailResVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListStockInboundDetailResVo
     */
    message?: string;
    /**
     * 
     * @type {Array<StockInboundDetailResVo>}
     * @memberof ResponseListStockInboundDetailResVo
     */
    data?: Array<StockInboundDetailResVo>;
}

/**
 * Check if a given object implements the ResponseListStockInboundDetailResVo interface.
 */
export function instanceOfResponseListStockInboundDetailResVo(value: object): value is ResponseListStockInboundDetailResVo {
    return true;
}

export function ResponseListStockInboundDetailResVoFromJSON(json: any): ResponseListStockInboundDetailResVo {
    return ResponseListStockInboundDetailResVoFromJSONTyped(json, false);
}

export function ResponseListStockInboundDetailResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListStockInboundDetailResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(StockInboundDetailResVoFromJSON)),
    };
}

export function ResponseListStockInboundDetailResVoToJSON(json: any): ResponseListStockInboundDetailResVo {
    return ResponseListStockInboundDetailResVoToJSONTyped(json, false);
}

export function ResponseListStockInboundDetailResVoToJSONTyped(value?: ResponseListStockInboundDetailResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(StockInboundDetailResVoToJSON)),
    };
}

